import React, { useEffect } from "react";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import logo from "../assets/images/cdm-logo.png";
import "./Header.css";

const links = [
  ["#home", "Home"],
  ["#about-us", "About Us"],
  ["#services", "Services"],
  ["#portfolio", "Portfolio"],
  ["#contact-us", "Contact Us"],
];

const Header = () => {
  useEffect(() => {
    let lastScrollTop = window.scrollY;
    const navbar = document.getElementById("navbar");
    const onScroll = () => {
      const scrollTop = Math.max(0, window.scrollY);
      navbar.style.top = scrollTop > lastScrollTop ? "-150px" : "0px";
      lastScrollTop = scrollTop;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => {
    Offcanvas.getInstance(document.getElementById("mobileMenu"))?.hide();
  };

  const navigation = (mobile = false) => links.map(([href, label]) => (
    <li className="nav-item" key={href}>
      <a className="nav-link" href={href} onClick={mobile ? closeMenu : undefined}>{label}</a>
    </li>
  ));

  return (
    <>
      <header className="header inter" id="navbar">
        <nav className="navbar navbar-expand-lg blue-bg shadow-sm" aria-label="Main navigation">
          <div className="container">
            <a className="navbar-brand" href="#home">
              <img src={logo} className="img-fluid" alt="Core Digital Marketing home" />
            </a>
            <button className="navbar-toggler border-0 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu" aria-label="Open navigation">
              <span aria-hidden="true">☰</span>
            </button>
            <div className="collapse navbar-collapse d-none d-lg-block">
              <ul className="navbar-nav ms-auto">{navigation()}</ul>
            </div>
          </div>
        </nav>
      </header>
      <div className="offcanvas offcanvas-start inter" id="mobileMenu" tabIndex={-1} aria-labelledby="mobileMenuLabel">
        <div className="offcanvas-header border-bottom">
          <h2 className="visually-hidden" id="mobileMenuLabel">Navigation</h2>
          <a className="navbar-brand" href="#home" onClick={closeMenu}>
            <img src={logo} className="img-fluid" alt="Core Digital Marketing home" />
          </a>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close navigation" />
        </div>
        <nav className="offcanvas-body" aria-label="Mobile navigation">
          <ul className="navbar-nav">{navigation(true)}</ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
